export default __webpack_public_path__ + "static/media/bg-2.0169464b.jpg";